export class IsVisibleOnFilterBaseValueConverter {
    toView(array) {
        return array.filter((item) => item.hasOwnProperty('IsVisibleOnFilter') && item['IsVisibleOnFilter'] == true);
    }
}